export const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
  },
  container: {
    flex: '1 0 auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100vw'
    }
  }
})
